import { FC } from "react";
import { StyleSheet } from "react-native";

import { OnboardingIntroContentOnDark } from "@/blocks/OnboardingIntroContentOnDark";
import { VnBox } from "@/components/VnBox";
import { VnImage } from "@/components/VnImage";
import { VnScrollView } from "@/components/VnScrollView";
import { OnboardingScreenType } from "@/domain/onboarding";

import introBackground from "./assets/intro-background.jpg";

const BACKGROUND_POSITION = { left: "47%", top: "0%" } as const;

export const IntroStepWithImage: FC<OnboardingScreenType> = ({
  width,
  headerHeight,
  footerHeight,
}) => (
  <VnBox style={{ width }} className="flex-1">
    <VnImage
      source={introBackground}
      style={StyleSheet.absoluteFill}
      contentFit="cover"
      contentPosition={BACKGROUND_POSITION}
      accessible={false}
    />
    <VnBox style={StyleSheet.absoluteFill} className="bg-black/40" />

    <VnScrollView
      className="flex-1"
      style={{ marginTop: headerHeight, marginBottom: footerHeight }}
      contentContainerClassName="items-center justify-end px-7 pb-6 pt-4"
      contentContainerStyle={{ flexGrow: 1 }}>
      <VnBox className="w-full gap-8 md:max-w-screen-sm">
        <OnboardingIntroContentOnDark />
      </VnBox>
    </VnScrollView>
  </VnBox>
);
